import Button from 'devextreme-react/button';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSaveCabinetInstallerChangeOrderScriptForm } from '../api/save-cabinetInstallerChangeOrderScriptForm';

const CabinetInstallerChangeOrderScriptForm: React.FC<{
    retailOrderID: number,
    retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {

    const initialFormState = {
        greetingNameCheckbox: false,
        greetingNameTextbox: '',
        greetingCompanyTextbox: '',
        greetingCustomerTextbox: '',
        changeOrderConfirmingCheckbox: false,
        actionStepsPleaseCheckbox: false,
        actionStepsCannotLocateCheckbox: false,
        actionStepsGreatCheckbox: false,
        explainChangeIfTheCustomerCheckbox: false,
        explainChangeInTheEventCheckbox: false,
        closingIfYouNeedCheckbox: false,
        closingThanksCheckbox: false,
        notesTextbox: ''
    };
    const [formState, setFormState] = useState(initialFormState);

    const saveChangeOrderScriptForm = useSaveCabinetInstallerChangeOrderScriptForm(
        {
            formObject: {
                retailOrderID,
                retailOrderNo: retailOrderNumber,
                    ...formState
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleReset = () => {
        setFormState(initialFormState);
    };

    return (
        <div>
            <div className='main-header'>
                <h1>Cabinets Call Script - Installer Change Order</h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Greeting & Introduction</span></div>
                <div className='section-row'>
                    <input type="CheckBox"
                        checked={formState.greetingNameCheckbox} onChange={(e) => setFormState({ ...formState, greetingNameCheckbox: e.target.checked })} />
                    <span className='standard-margin-left-distance'>
                        “Hi, this is (Your Name)
                    </span>

                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="greetingNameTextbox"
                            value={formState.greetingNameTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>

                    <span className='standard-margin-left-distance'>
                        from <i>(Your Company)</i>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="greetingCompanyTextbox"
                            value={formState.greetingCompanyTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <label className='standard-margin-top-distance'>
                        I’m calling in regards to the final install labor costs that was submitted for customer (Customer Name)’s
                    </label>
                    <span className='standard-margin-top-distance'>
                        <input
                            type="text"
                            name="greetingCustomerTextbox"
                            value={formState.greetingCustomerTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <span className='standard-margin-left-distance'>
                        cabinet project.”
                    </span>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Confirming the Change Order:</span></div>
                <div className='section-row'>
                    <label>
                        <span>
                            <input type="CheckBox"
                                checked={formState.changeOrderConfirmingCheckbox} onChange={(e) => setFormState({ ...formState, changeOrderConfirmingCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            “I wanted to let you know that we are confirming the final details, and it includes all labor items
                            that are required for the installation. The updated details should now be in your system for
                            review. Can you please confirm that you received it?”
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Action Steps - Did Not Receive:</span></div>
                <div className='section-row'>
                    <label>
                        <span>
                            <input type="CheckBox"
                                checked={formState.actionStepsPleaseCheckbox} onChange={(e) => setFormState({ ...formState, actionStepsPleaseCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            “Please check your junk folder and please let me know if you find it there”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span>
                            <input type="CheckBox"
                                checked={formState.actionStepsCannotLocateCheckbox} onChange={(e) => setFormState({ ...formState, actionStepsCannotLocateCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            [cannot locate] “No problem, when we hang up, I will contact Sage Surfaces Support to assist in
                            ensuring that you receive it.”
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Action Steps - Received:</span></div>
                <div className='section-row'>
                    <label>
                        <span>
                            <input type="CheckBox"
                                checked={formState.actionStepsGreatCheckbox} onChange={(e) => setFormState({ ...formState, actionStepsGreatCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            “Great! Please let me know if you need any further details or if you’d like to discuss any part of the
                            project.
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Explain Change / Cancellation:</span></div>
                <div className='section-row'>
                    <label>
                        <span>
                            <input type="CheckBox"
                                checked={formState.explainChangeIfTheCustomerCheckbox} onChange={(e) => setFormState({ ...formState, explainChangeIfTheCustomerCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            “If the customer makes any changes, please let us know as soon as possible so we can submit
                            updated final install labor cost details.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span>
                            <input type="CheckBox"
                                checked={formState.explainChangeInTheEventCheckbox} onChange={(e) => setFormState({ ...formState, explainChangeInTheEventCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            “In the event that the customer decides not to move forward with purchasing installation, please
                            let us and/or Sage Support know as soon as possible. Please also inform the customer that
                            because measure has been completed and they are not purchasing installation - the measure fee
                            cannot be credited back to them.”
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Closing:</span></div>
                <div className='section-row'>
                    <label>
                        <span>
                        <input type="CheckBox"
                                checked={formState.closingIfYouNeedCheckbox} onChange={(e) => setFormState({ ...formState, closingIfYouNeedCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            “If you need anything further or any additional information, don’t hesitate to reach out. Thanks for
                            your time, and we look forward to working with you to complete the install.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span>
                        <input type="CheckBox"
                                checked={formState.closingThanksCheckbox} onChange={(e) => setFormState({ ...formState, closingThanksCheckbox: e.target.checked })} />
                        </span>
                        <span className='standard-margin-left-distance'>
                            “Thanks again. Have a great day!”
                        </span>
                    </label>
                </div>

                <div className='section-row'>
                    Notes:
                    <textarea
                        className='input-fullsize-large-height'
                        value={formState.notesTextbox}
                        onChange={handleTextInputChange}
                        placeholder="Note"
                        name='notesTextbox'
                        rows={5}
                        cols={40}
                    />
                </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        saveChangeOrderScriptForm.mutate();
                    }} >
                </Button>
            </div>
        </div >
    );
};

export default CabinetInstallerChangeOrderScriptForm;
